import axiosInstance from "@/api/axiosInstance";
import { WhatsNew } from "@/common/model/WhatsNew";
import { WhatsNewResponseDTO } from "@/common/model/dto/response/WhatsNewResponse.dto";
import { ENDPOINTS } from "@/constants/api";
import { requestHandler } from "@/helpers/requestHandler";
import { WhatsNewMapper } from "@/mappers/WhatsNewMapper";

export const WhatsNewService = {
  async fetchAll(): Promise<WhatsNew[]> {
    return requestHandler<WhatsNew[]>(async () => {
      const response = await axiosInstance.get(ENDPOINTS.WHATSNEW.DEFAULT);
      return response.data.map((whatsNew: WhatsNewResponseDTO) =>
        WhatsNewMapper.fromResponse(whatsNew)
      );
    }, "WhatsNewService -> fetchAll");
  },

  async create(whatsNew: Partial<WhatsNew>): Promise<WhatsNew> {
    return requestHandler<WhatsNew>(async () => {
      const response = await axiosInstance.post(
        ENDPOINTS.WHATSNEW.DEFAULT,
        WhatsNewMapper.toRequest(whatsNew)
      );
      if (response.data.error) {
        throw new Error(response.data.message);
      }
      return WhatsNewMapper.fromResponse(response.data);
    }, "WhatsNewService -> create");
  },

  async update(id: string, whatsNew: Partial<WhatsNew>): Promise<WhatsNew> {
    return requestHandler<WhatsNew>(async () => {
      const response = await axiosInstance.put(
        `${ENDPOINTS.WHATSNEW.DEFAULT}/${id}`,
        WhatsNewMapper.toRequest(whatsNew)
      );
      if (response.data.error) {
        throw new Error(response.data.message);
      }
      return WhatsNewMapper.fromResponse(response.data);
    }, "WhatsNewService -> update");
  },

  async delete(id: string): Promise<void> {
    return requestHandler<void>(async () => {
      await axiosInstance.delete(`${ENDPOINTS.WHATSNEW.DEFAULT}/${id}`);
    }, "WhatsNewService -> delete");
  },
};
